import AggregateControllerConstructor from "csi/heading/AggregateController";
import declare from "dojo/_base/declare";

const AggregateAttributeController = declare(AggregateControllerConstructor, {
	// TODO - fill in what is needed for Go to Dialog in aggregate store case
});

export = AggregateAttributeController;
